
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pasha/[[...search]]",
      function () {
        return require("private-next-pages/pasha/[[...search]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pasha/[[...search]]"])
      });
    }
  